
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ContainerPaper from '../paper/ContainerPaper';
import Project from './Project';
import projectData from '../../resources/json/projects.json';
import StandardHeaderDropDownSelector from '../common/dropdowns/standard/StandardDropDownSelector';

import { desktopMainContainer, desktopContentContainerPaperStyle } from '../../styles/shared/desktop';
import { mobileMainContainer } from '../../styles/shared/mobile';

import { sectionHeaderStyle, sectionTextStyle } from '../../styles/shared/variables';

import { desktopContentContainerPaperDivStyle, projectHeaderStyle, desktopDropdownMenuContainer } from './styles/desktop';

const styles = theme => ({
    root: theme.mixins.gutters({
        marginTop: theme.spacing.unit * 3,
    })
});


class Projects extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            project: '',
            value: 0,
            projectData: ''
        }
        this.handleMenuChange = this.handleMenuChange.bind(this);    

    }

    handleMenuChange = (menuSelectionIndex) => {
        this.setState({ value: menuSelectionIndex, projectData: projectData[menuSelectionIndex]});
        
    };


    generateContentData() {
     
        if (this.state.projectData.contents != null) {
            return <Project projectData={this.state.projectData} />
        }

    }

    generateProjectList(){
        let listOfProjectTitles = [];
        projectData.map(function (project, index) {
            listOfProjectTitles.push(project.projectName);
        });

        return listOfProjectTitles;
    }

    render() {
        const { classes, children, style, deviceType } = this.props;
        let showMobile = deviceType === 'mobile' ? true : false;
        return (
            <div id='projects-page-container' style={showMobile ? mobileMainContainer : desktopMainContainer}>

                    <ContainerPaper id={'projects-page-sub-container'} style={desktopContentContainerPaperStyle}>
                        <div id='container-paper-content-div' style={desktopContentContainerPaperDivStyle}>
                            <div style={{ ...sectionHeaderStyle, ...projectHeaderStyle }}>
                                Projects
                            </div>
                            <div style={{ sectionTextStyle, textAlign: 'center' }}>
                                This page contains projects completed while attending the University of Pittsburgh, Pennsylvania State University, as well as projects outside of the classroom.
                                Choose a project from the dropdown below to expand project details and demos.
                            </div>
                            <div id='project-dropdown-container' style={desktopDropdownMenuContainer}>
                                <StandardHeaderDropDownSelector showMobile={showMobile} handleSelection={this.handleMenuChange} menuId={'project-dropdown-menu'} optionsList={this.generateProjectList()} shouldDefault={false}/>
                            </div>
                        </div>
                        {this.generateContentData()}
                    </ContainerPaper>
            </div >
        );
    }
}

Projects.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Projects);


// WEBPACK FOOTER //
// ./src/components/projects/Projects.js